// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2PWRP","label":"Completed_label__2DQQx"};